<template>
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.25 9.5013C3.92917 9.5013 3.65451 9.38707 3.42604 9.15859C3.19757 8.93012 3.08333 8.65547 3.08333 8.33464V1.33464C3.08333 1.0138 3.19757 0.739149 3.42604 0.510677C3.65451 0.282205 3.92917 0.167969 4.25 0.167969H9.5C9.82083 0.167969 10.0955 0.282205 10.324 0.510677C10.5524 0.739149 10.6667 1.0138 10.6667 1.33464V8.33464C10.6667 8.65547 10.5524 8.93012 10.324 9.15859C10.0955 9.38707 9.82083 9.5013 9.5 9.5013H4.25ZM4.25 8.33464H9.5V1.33464H4.25V8.33464ZM1.91667 11.8346C1.59583 11.8346 1.32118 11.7204 1.09271 11.4919C0.864236 11.2635 0.75 10.9888 0.75 10.668V2.5013H1.91667V10.668H8.33333V11.8346H1.91667Z"
      fill="currentColor"
    />
  </svg>
</template>
